import styled from '@emotion/styled';
import KizenTypography from 'app/kizentypo';

export const WarningBody = styled(KizenTypography)`
  text-align: center;
`;
